import {memoWithType} from "@hosttools/frontend";
import {Textarea, TextareaInput} from "@hosttools/frontend/components";
import {useCallback, useMemo} from "react";

type LanguageText = {
    language: string;
    value: string;
};

type Props = {
    isInvalid?: boolean;
} & StrictUnion<
    | {
          isArray: true;
          languageTexts?: LanguageText[];
          displayLanguage?: string;
          onChange: (value: LanguageText[]) => void;
      }
    | {
          languageText?: LanguageText;
          onChange: (value: LanguageText) => void;
      }
>;

function TextAreaForm({
    isArray,
    languageTexts,
    languageText,
    isInvalid,
    displayLanguage = "en",
    onChange
}: Props) {
    const text = useMemo(() => {
        if (isArray) {
            return languageTexts?.find(text => text.language.toLowerCase() === displayLanguage)
                ?.value;
        }
        return languageText?.value ?? "";
    }, [isArray, displayLanguage, languageText, languageTexts]);

    const handleChangeText = useCallback(
        (value: string) => {
            if (isArray) {
                onChange([{language: displayLanguage, value}]);
            } else {
                onChange({language: displayLanguage, value});
            }
        },
        [displayLanguage, isArray, onChange]
    );

    return (
        <Textarea isInvalid={isInvalid}>
            <TextareaInput value={text} onChangeText={handleChangeText} />
        </Textarea>
    );
}

export default memoWithType(TextAreaForm);
